<div class="pass-detail-card-modal">
    <finder-generic-text
        *ngIf="data?.genericText"
        [data]="data.genericText">
    </finder-generic-text>
    <div class="space-element"></div>
    <div class="modal-buttons" *ngIf="data?.cta?.button">
        <finder-button
            id="Modal-{{data.title}}-{{button?.ctaButtonText}}"
            *ngFor="let button of data.cta.button"
            [href]="button?.ctaButtonUrl"
            [target]="button?.ctaButtonTarget"
            [theme]="button?.ctaButtonStyle"
            >{{button?.ctaButtonText}}
        </finder-button>
    </div>
</div>
